import React, { useEffect, useState } from "react";
import "./GallerySection.scss";
import gallery1 from "../GallerySection/gallery1.jpg";
import gallery2 from "../GallerySection/gallery2.jpg";
import gallery3 from "../GallerySection/gallery3.jpg";
import gallery4 from "../GallerySection/gallery4.jpg";
import gallery5 from "../GallerySection/gallery5.jpg";

const galleryImages = [
  {
    src: gallery1,
    alt: "Instalaciones de maquinaria industrial 1",
  },
  {
    src: gallery2,
    alt: "Instalaciones de maquinaria industrial 2",
  },
  {
    src: gallery3,
    alt: "Instalaciones de maquinaria industrial 3",
  },
  {
    src: gallery4,
    alt: "Instalaciones de maquinaria industrial 4",
  },
  {
    src: gallery5,
    alt: "Instalaciones de maquinaria industrial 5",
  },
];

const GallerySection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const openModal = (index) => {
    setActiveIndex(index);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setActiveIndex(null);
    document.body.style.overflow = "auto";
  };

  const showPrev = () => {
    setActiveIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1,
    );
  };

  const showNext = () => {
    setActiveIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1,
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeIndex === null) return;

      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [activeIndex]);

  return (
    <>
      <section className="gallery-section">
        <div className="container">
          <div className="gallery-section__heading">
            <div className="gallery-section__eyebrow">Instalaciones</div>

            <h2 className="gallery-section__title">
              Conoce más de nuestras instalaciones y el entorno donde
              trabajamos.
            </h2>

            <p className="gallery-section__subtitle">
              Contamos con espacios adecuados para la exhibición y resguardo de
              maquinaria industrial, brindando confianza, orden y seguridad en
              cada operación. Aquí es donde seleccionamos, preparamos y
              entregamos equipos con el compromiso de calidad que nos distingue.
            </p>
          </div>

          <div className="gallery-section__grid">
            {galleryImages.map((image, index) => (
              <button
                key={index}
                type="button"
                className={`gallery-section__item gallery-section__item--${
                  index === 0 ? "large" : "normal"
                }`}
                onClick={() => openModal(index)}
              >
                <img src={image.src} alt={image.alt} />
                <div className="gallery-section__overlay">
                  <span>Ver imagen</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {activeIndex !== null && (
        <div className="gallery-modal" onClick={closeModal}>
          <div
            className="gallery-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="gallery-modal__close"
              onClick={closeModal}
              aria-label="Cerrar galería"
            >
              ×
            </button>

            <button
              type="button"
              className="gallery-modal__nav gallery-modal__nav--prev"
              onClick={showPrev}
              aria-label="Imagen anterior"
            >
              ‹
            </button>

            <div className="gallery-modal__image-wrapper">
              <img
                src={galleryImages[activeIndex].src}
                alt={galleryImages[activeIndex].alt}
                className="gallery-modal__image"
              />
            </div>

            <button
              type="button"
              className="gallery-modal__nav gallery-modal__nav--next"
              onClick={showNext}
              aria-label="Siguiente imagen"
            >
              ›
            </button>

            <div className="gallery-modal__footer">
              <p>
                Imagen {activeIndex + 1} de {galleryImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GallerySection;
